import { useState, useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
const API = `${BACKEND_URL}/api`;

export const useCMS = (section = null) => {
  const [content, setContent] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchContent();
  }, [section]);

  const fetchContent = async () => {
    try {
      const url = section ? `${API}/content?section=${section}` : `${API}/content`;
      const response = await axios.get(url);
      
      // Validate response is an array
      if (!Array.isArray(response.data)) {
        console.error('CMS API returned non-array response:', response.data);
        setContent({});
        return;
      }
      
      // Convert array to object with key as property
      const contentObj = {};
      response.data.forEach(item => {
        contentObj[item.key] = item.value;
      });
      
      setContent(contentObj);
    } catch (err) {
      console.error('Error fetching CMS content:', err);
      console.error('Error details:', err.response?.data, err.response?.status);
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  const get = (key, fallback = '') => {
    return content[key] || fallback;
  };

  return { content, get, loading, error, refetch: fetchContent };
};

export const useServices = () => {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchServices();
  }, []);

  const fetchServices = async () => {
    try {
      const response = await axios.get(`${API}/services`);
      
      // Validate response is an array
      if (!Array.isArray(response.data)) {
        console.error('Services API returned non-array response:', response.data);
        setServices([]);
        return;
      }
      
      setServices(response.data);
    } catch (err) {
      console.error('Error fetching services:', err);
      console.error('Error details:', err.response?.data, err.response?.status);
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  return { services, loading, error, refetch: fetchServices };
};